import {DEFAULT_VALUES, TicketPayload} from "src/constants/wim";

export interface DropdownOption {
    value: string;
    label: string;
}

export interface WorkItemDetails {
    workitemType: string;
    capabilityPrimitive: string;
    processPrimitive: string;
    program: string;
    ctiConfig: string;
}

export interface CTIConfig {
    category: string;
    type: string;
    item: string;
    resolverGroup: string;
    simFolderId: string;
}

export interface PillarResponse {
    pillarDetails: {
        [pillarName: string]: {
            [systemName: string]: WorkItemDetails[];
        };
    };
}

export const buildTicketPayload = (
    workItemId: string,
    contextId: string,
    username: string,
    title: string,
    description: string,
    pillar?: string,
    system?: string,
    workItemType?: string,
    capabilityPrimitive?: string,
    processPrimitive?: string,
    program?: string,
    workItemTypeDetails?: CTIConfig
): TicketPayload => ({
    workItemId,
    requester: {
        name: username
    },
    context: {
        contextId,
        contextType: DEFAULT_VALUES.CONTEXT_TYPE
    },
    priority: DEFAULT_VALUES.PRIORITY,
    description: description || DEFAULT_VALUES.DEFAULT_DESCRIPTION,
    title,
    tags: {
        Pillar: pillar || "",
        System: system || "",
        CapabilityPrimitive: capabilityPrimitive || "",
        ProcessPrimitive: processPrimitive || "",
        Program: program || "",
        WorkItemType: workItemType || "",
        User: username,
        CreatedViaSWOUI:"True"
    },
    workForce: {
        sim: {
            category: workItemTypeDetails?.category || "",
            type: workItemTypeDetails?.type || "",
            item: workItemTypeDetails?.item || "",
            resolverGroup: workItemTypeDetails?.resolverGroup || "",
            simFolderId: workItemTypeDetails?.simFolderId || "",
            user: username
        }
    },
    isOutputRequired: DEFAULT_VALUES.IS_OUTPUT_REQUIRED
});
